<template>
  <div>
    <van-overlay :show="isPlay"  @click="closeEvent()">
      <div :id="id" class="canvas"></div>
      <span class="text">点击任意处关闭</span>
    </van-overlay>
    <van-overlay :show="overlayShow" class="overlayShow">
      <div class="wrapper">
        <div class="block">
          <img :src="imgUrl" :class="imgType"/>
        </div>
      </div>
    </van-overlay>
    <WinningBlindBoxGifts ref="winningBlindBoxGifts" @watchReward="watchReward"/>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Icon, Toast,Overlay} from "vant";
import SVGA from 'svgaplayerweb';
import { Howl } from 'howler';//不可删除，播放特效需要声音

import WinningBlindBoxGifts from "@/components/common/gift/winning-blind-box-gifts";
var player;

Vue.use(Icon)
    .use(Overlay)
export default {
  name: "reward-special-effects",
  components: {
    WinningBlindBoxGifts
  },
  props: {
    svgaUrl:{
      type: String,
      required: true,
      default: ''
    },
    id:{
      type: String,
      default: 'demoCanvas'
    },
    loops:{
      type: Number,
      default: 1
    },
    imgUrl:{
      type:String,
      default:'/static/images/default/reward/monetary-reward.gif'
    },
    timeout:{
      type:Number,
      default:900
    },
  },
  data (){
    return {
      isPlay: false,
      overlayShow: false,
      imgType: '',
      currentIndex:0,
      timeElapsed:0,// 记录已经过去的时间，单位为秒
    }
  },
  computed:{
  },
  watch:{
  },

  //切换页面关闭播放
  destroyed(){
    this.closeEvent()
  },
  methods: {
    watchReward(svgaUrl) {
      this.specialEffects(svgaUrl)
    },
    timedTask(winningGiftList) {
      let that = this;
      let timerId = setInterval(function () {
        // 每秒执行一次的任务
        if (!that.isPlay) {
          // 如果已经得到了结果，则清除定时任务
          if (that.currentIndex < winningGiftList.length) {
            winningGiftList[that.currentIndex].type='gift'
            if (winningGiftList[that.currentIndex].svgaUrl)
              that.specialEffects(winningGiftList[that.currentIndex].svgaUrl);
            that.currentIndex++
            that.timeElapsed = 0
          } else {
            that.timeElapsed = 60
          }
        }
        if (that.timeElapsed >= 60) {
          // 如果已经过了30秒但还没有得到结果，则清除定时任务
          that.timeElapsed = 0
          that.currentIndex = 0
          clearInterval(timerId);
        } else {
          that.timeElapsed++; // 增加已经过去的时间
        }
      }, 500); // 每半秒执行一次
    },

    closeEvent(){
      player.stopAnimation()
      player._videoItem = null
      this.isPlay=false
      // eslint-disable-next-line no-undef
      Howler.unload();
    },
    //svag特效
    specialEffects(svgaUrl,isPayment){
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      this.isPlay=true
      player=new SVGA.Player('#'+this.id);
      const parser = new SVGA.Parser('#'+this.id); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
      parser.load(svgaUrl,(videoItem) => {
        Toast.clear();
        player.loops = this.loops;  //设置循环播放次数是 1
        player.setVideoItem(videoItem);
        player.stepToFrame(0, true); // 从指定帧开始播放动画
        //"Fill" | "AspectFill" | "AspectFit"特定比例模式
        player.onFinished( ()=>{
          player._videoItem = null
          this.isPlay = false
          // eslint-disable-next-line no-undef
          Howler.unload();
        })//回调函数
      },function (err){
        Toast.clear();
        Dialog.alert({
          title: '加载失败',
          message: err
        })
      });
    },
    //清除svag特效
    clearCartoon(){
      const player = new SVGA.Player('#'+this.id);
      player.clear()
    },
    //金额特效
    amountSpecialEffects(imgUrl) {
      this.imgType = 'giftAmount';
      this.overlayShow = true;
      this.imgUrl = imgUrl;
      //图片显示时间
      setTimeout(() => {
        this.overlayShow = false;
      }, 950);
    },
    //图片特效
    imgSpecialEffects(imgUrl){
      this.imgType = 'giftImg';
      this.overlayShow=true;
      this.imgUrl=imgUrl;
      setTimeout(()=>{
        this.overlayShow=false;
      },2000);
    },
    // 礼物特效
    rewardSpecialEffects(specialEffects){
      if (specialEffects.winningGiftList && specialEffects.winningGiftList.length >= 1) {
        this.$refs.winningBlindBoxGifts.show(specialEffects.winningGiftList);
        this.timedTask(specialEffects.winningGiftList)
        return
      }

      if (specialEffects.type=='gift'){
        if (specialEffects.svgaUrl) {
          this.specialEffects(specialEffects.svgaUrl);
        } else {
          this.overlayShow = true;
          this.imgSpecialEffects(specialEffects.imgUrl);
        }
      }else if (specialEffects.type=='amount'){
        this.overlayShow=true;
        this.amountSpecialEffects('/static/images/default/monetary-reward.gif');
      }
    }
  },
}
</script>

<style lang="less" scoped>
.text{
  color: #fff;
  font-size: 14px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10vw;
  z-index: 10000;
  background: rgba(0,0,0,0.5);
  padding: 5px 10px;
}
.canvas{
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 9999;
  left: 0px;
  bottom: calc(0px + constant(safe-area-inset-bottom));
  bottom: calc(0px + env(safe-area-inset-bottom));
  pointer-events: none;
  text-align: left;
  /deep/canvas{
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    transform: none !important;
    width: 100vw !important;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    display: flex;
    flex-flow: column;
    align-items: center;
    width: 100%;

    .giftImg {
      max-width: 85%;
      max-height: 50%;
    }
    .giftAmount {
      width: 100%;
    }
  }
}
/deep/ .van-overlay{
  //background-color: transparent;
  z-index: 9999;
}
</style>
